<template>
	<div>
		<b-form>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Product</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="productStatus"
							v-model="subscriberProduct.product"
						></b-form-input>
						<b-form-invalid-feedback :state="productStatus">
							Product name needs to include "{{ customer.toLowerCase() }}" (case insensitive) and no
							whitespaces.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Description</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="descriptionStatus"
							v-model="subscriberProduct.description"
						></b-form-input>
						<b-form-invalid-feedback :state="descriptionStatus">
							Please select a valid Description.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">Start Date</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="startDateStatus"
							v-model="subscriberProduct.startDate"
							type="datetime-local"
						></b-form-input>
						<b-form-invalid-feedback :state="startDateStatus">
							Please select a valid Start Date.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col xl="3" lg="3" sm="3">
					<p class="mt-3">
						<span class="h3">End Date</span>
					</p>
				</b-col>
				<b-col xl="9" lg="9" sm="9">
					<b-form-group label-for="input-1">
						<b-form-input
							id="input-1"
							:state="endDateStatus"
							v-model="subscriberProduct.endDate"
							type="datetime-local"
						></b-form-input>
						<b-form-invalid-feedback :state="endDateStatus">
							Please select a valid End Date.
						</b-form-invalid-feedback>
					</b-form-group>
				</b-col>
			</b-row>

			<hr />
			<div class="mt-3 d-flex justify-content-between">
				<base-button type="white" title="Close" v-on:click="modalClose()"> Close </base-button>
				<base-button
					v-if="!update"
					type="primary"
					title="Save"
					:disabled="submitDisabled"
					v-on:click="saveSubmit"
					:loading="submitLoading"
				>
					Save
				</base-button>
				<base-button
					v-if="update"
					type="primary"
					title="Save"
					:disabled="submitDisabled"
					v-on:click="saveUpdateSubmit"
					:loading="submitLoading"
				>
					Save
				</base-button>
			</div>
		</b-form>
	</div>
</template>

<script>
import {VueTelInput} from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import productManagementService from "../../../../common/api-services/product-management-service";
import handleResponse from "../../../../common/directive/handlResponse";

export default {
	name: "Subscriber-Product-Form",
	props: ["update"],
	components: {
		VueTelInput,
	},
	computed: {
		productStatus() {
			// Product name needs to include the customer's name (case insensitive)
			return (
				this.subscriberProduct.product.toLowerCase().includes(this.customer.toLowerCase()) &&
				!this.subscriberProduct.product.includes(" ")
			);
		},
		descriptionStatus() {
			return this.subscriberProduct.description.length > 0;
		},
		startDateStatus() {
			return this.subscriberProduct.startDate.length > 0;
		},
		endDateStatus() {
			return this.subscriberProduct.endDate.length > 0;
		},
		submitDisabled() {
			return !(this.productStatus && this.descriptionStatus && this.startDateStatus && this.endDateStatus);
		},
	},
	data() {
		return {
			subscriberProduct: {
				productId: 0,
				product: "",
				description: "",
				startDate: "",
				endDate: "",
			},
			dialCode: "",
			submitLoading: false,
			customer: "",
		};
	},
	mounted() {
		this.$root.$on("ChangeSubscriberProductOldData", res => {
			this.subscriberProduct.productId = res.productId;
			this.subscriberProduct.product = res.product;
			this.subscriberProduct.description = res.description;
			this.subscriberProduct.startDate = res.startdate;
			this.subscriberProduct.endDate = res.endDate;
		});

		this.customer =
			String(process.env.VUE_APP_CLIENT).slice(0, 1).toUpperCase() + String(process.env.VUE_APP_CLIENT).slice(1);
		this.subscriberProduct.product = this.customer;
	},
	methods: {
		modalClose() {
			this.$bvModal.hide("add-subscriber-products");
			this.$bvModal.hide("edit-subscriber-products");
		},

		async saveSubmit() {
			// console.log(this.subscriberProduct)

			this.submitLoading = true;

			await productManagementService
				.addSubscriberProducts(this.subscriberProduct)
				.then(res => {
					// console.log(res)
					this.$toast.success("Product Added Successfully");
				})
				.catch(err => {
					// console.log(err)
					this.$toast.error("Error adding new product");
				});

			this.modalClose();
			this.$root.$emit("getProductListFunc");
		},

		async saveUpdateSubmit() {
			// console.log(this.subscriberProduct)

			// if (this.subscriberProduct.productId && this.subscriberProduct.product && this.subscriberProduct.description && this.subscriberProduct.startDate && this.subscriberProduct.endDate) {
			this.submitLoading = true;

			await productManagementService
				.updateSubscriberProducts(this.subscriberProduct)
				.then(res => {
					// console.log(res)
					this.$toast.success("Product Added Successfully");
				})
				.catch(err => {
					// console.log(err)
					this.$toast.error("Error adding new product");
				});

			this.modalClose();
			this.$root.$emit("getProductListFunc");
			// } else {
			//   this.$root.$emit('danger', 'Please input valid data');
			// }
		},
	},
};
</script>
